import * as React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Sidebar} from '../navigation';

type OwnProps = {
    sidebarMountId: string;
};
type Props = OwnProps & ContextRouter;

class SidebarPortalledComponent extends React.Component<Props> {
    sidebarMount: HTMLElement | null | undefined;

    constructor(props: Props) {
        super(props);
        this.sidebarMount = document.getElementById(props.sidebarMountId);
        // Remove existing (plachoelder or previously-rendered nut.js) sidebar contents.
        while (this.sidebarMount && this.sidebarMount.firstChild) {
            this.sidebarMount.removeChild(this.sidebarMount.firstChild);
        }
    }

    render() {
        const mount = this.sidebarMount;
        if (!mount) {
            return null;
        }

        const activeTab = getActiveTabNameFromPathname(this.props.location.pathname);

        // @ts-expect-error
        return ReactDOM.createPortal(<Sidebar activeTab={activeTab} />, mount);
    }
}

function getActiveTabNameFromPathname(pathname: string) {
    const basePath = pathname.split('/')[1];

    switch (basePath) {
        case 'sales':
            return 'sales';
        case 'companies':
        case 'company':
            return 'accounts';
        case 'people':
        case 'person':
            return 'contacts';
        case 'lead':
            return 'leads';
        case 'trash':
        case 'my-account':
        case 'setup':
            return 'manage';
        case 'inbox':
            return 'engagement';
        default:
            return basePath;
    }
}

// @ts-expect-error
export const SidebarPortalled = withRouter<OwnProps>(SidebarPortalledComponent);
